import {
  createBrowserRouter,

} from "react-router-dom";
import { Home } from "../Screens/Home";
import { useRef } from "react";
import { NavBar } from "../Components/NavBar/NavBar";
import { ChannelDetail } from "../Screens/Channel";
import { Dashboard } from "../Components/Channel/Dashboard/DashBoard";
import { Detail } from "../Components/Channel/Detail/Detail";
import { ProductTable } from "../Components/Channel/Product/Product";
import { OrderTable } from "../Components/Channel/Order/Order";
import { Product } from "../Screens/Product";
import { Order } from "../Screens/Order";
import { SettingDetail } from "../Components/Channel/Settings/Detail";
import { GenApikey } from "../Components/GenApikey/Detail";
import { Login } from "../Screens/Login";
import ProtectedRoute from "../Utils/ProtectedRoutes/ProtectedRoutes";
import UnProtectedRoute from "../Utils/UnProtectedRoute/UnProtectedRoutes";
import { CreateChannel } from "../Screens/CreateForm";

export const Routes = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute> <NavBar /> </ProtectedRoute>,
    children: [
      {
        path: "/",
        element: (
          <Home />
        ),
      },
      {
        path: "/genapikey",
        element: (
          <GenApikey /> 
        ),
      },
      {
        path: "/Channel/:slug",
        element: (
          <ChannelDetail />
        ),
        children: [
          {
            path: "/Channel/:slug",
            element: (
              <Dashboard />
            )
          },
          {
            path: "/Channel/:slug/Detail",
            element: (
              <Detail />
            )
          },
          {
            path: "/Channel/:slug/Product",
            element: (
              <ProductTable />
            )
          },
          {
            path: "/Channel/:slug/Order",
            element: (
              <OrderTable />
            )
          },
          {
            path: "/Channel/:slug/Settings",
            element: (
              <SettingDetail />
            )
          } 


        ]
      },
      {
        path: "/Product/:slug",
        element: (
          <Product />
        ),
      },
      {
        path: "/Order/:slug",
        element: (
          <Order />
        ),
      },
      {
        path: "CreateChannel",
        element: (
          <CreateChannel />
        ),
      },


    ]
  },
  // {
  //   path: "/genapikey",
  //   element: (
  //     <ProtectedRoute> <GenApikey /></ProtectedRoute>
  //   ),
  // },
  {
    path: "/Login",
    element: (
      <UnProtectedRoute> <Login /></UnProtectedRoute>
    ),
  }


]);



